import { expiryLabel, expiryTone, type ExpiryTone } from '../../lib/pantryDisplay';

const STYLES: Record<ExpiryTone, string> = {
  // All pairs clear 4.5:1 (orange-ink/accent-ink were darkened for their soft tints).
  expired: 'border border-fail/30 bg-red-50 text-fail',
  soon: 'bg-orange-soft text-orange-ink',
  ok: 'bg-accent-soft text-accent-ink',
  none: 'bg-brand-soft text-brand',
};

export function ExpiryBadge({ daysUntilExpiry }: { daysUntilExpiry: number | null }) {
  const tone = expiryTone(daysUntilExpiry);
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLES[tone]}`}
    >
      {expiryLabel(daysUntilExpiry)}
    </span>
  );
}
